module.exports = "/fonts/iconsminds.svg?4f0a6dd7c406563e94320f94f5d5d505";